<template>
    <div v-on:scroll.passive="handleScroll">
        <audio id="intro_sound" autoplay muted>
            <source :src="require('@/assets/audio/intro.mp3')">
        </audio>
        <online-watcher dark/>
        <BGAnim v-if="$route.meta.animationBG"/>
        <app-loader :loading="firstLoadingLogin"/>
        <panel-menu v-if="$route.meta.menu" @click:menu="showDrawer = true"></panel-menu>
        <kimsa-drawer v-if="$route.meta.menu  && isOnBoardingDone" :onDrawerChange="onDrawerChange"
                      :show="showDrawer"></kimsa-drawer>
        <subscription-verifier>
            <attention-tool-set v-if="$route.name === 'panel.provider.specialist_daily_schedule'"/>
            <global-floating-spinner v-if="$route.meta && $route.meta.globalSpinner"/>
            <back-to-appointment-btn/>
            <v-app :class="{'subscription-cancelled': subscriptionWasCancelled, blurred}">
                <v-content>
                    <transition name="slide-y">
                        <router-view></router-view>
                    </transition>
                </v-content>
                <Particles
                    v-if="showParticles"
                    id="tsparticles"
                    url="/particles.json"
                />
                <w-footer v-if="$route.meta.footer"></w-footer>
                <login-dialog :onLoginSuccess="onLoginSuccess"></login-dialog>
            </v-app>
        </subscription-verifier>
        <v-snackbar
            class="snack-bar-custom"
            v-model="snackBar"
            :color="snackBarColor"
            top
            right
            multi-line
            :timeout="6000"
        >
            {{ snackBarText }}
            <v-btn
                color="white"
                flat
                @click="hideSnackBar"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
        <loading-spinner></loading-spinner>
    </div>

</template>

<script>
import PanelMenu from '@/components/common/panel/PanelMenu'
import KimsaDrawer from '@/components/common/panel/KimsaDrawer'
import WFooter from '@/components/common/WFooter'
import LoadingSpinner from '@/components/common/LoadingSpinner'
import LoginDialog from '@/components/common/LoginDialog.vue'
import AttentionToolSet from '@/components/appointments/attention/toolset/AttentionToolSet'

import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils'
import {initLaravelEcho} from '@/utils/Sockets'
import colors from 'vuetify/es5/util/colors'
import GlobalFloatingSpinner from "@/components/common/GlobalFloatingSpinner";
import BackToAppointmentBtn from "@/components/common/BackToAppointmentBtn";
import BGAnim from "@/components/common/BGAnim";
import AppLoader from "@/components/common/AppLoader";
import SubscriptionVerifier from "@/components/common/SubscriptionVerifier";
import OnlineWatcher from "./components/common/OnlineWatcher";

const host = process.env.VUE_APP_SOCKETS_SERVER
var jwt = ApiUtils.getJWT()
initLaravelEcho(host, jwt && jwt.access_token || '')

export default {
    name: 'App',
    components: {
        OnlineWatcher,
        SubscriptionVerifier,
        AppLoader,
        BGAnim,
        BackToAppointmentBtn,
        GlobalFloatingSpinner,
        PanelMenu,
        KimsaDrawer,
        WFooter,
        LoginDialog,
        LoadingSpinner,
        AttentionToolSet
    },
    async mounted() {
        try {
            var vm = this
            await vm.fetchRegions()
            await ApiUtils.fetchMe()
        } catch (error) {
            vm.setCurrentUser(null)
        } finally {
            vm.delayAppLoad()
        }
    },
    created() {
        const vm = this
        vm.setFirstLoginLoading(true)
        vm.$vuetify.theme.primary = '#0693e3' //'#4180d6'
        vm.$vuetify.theme.secondary = '#4987F1'
        vm.$vuetify.theme.accent = colors.pink.base
        vm.$vuetify.theme.error = colors.pink.lighten1
    },
    data() {
        return {
            showDrawer: false
        }
    },
    computed: {
        ...mapGetters(['subscriptionWasCancelled']),
        ...mapState([
            'blurred',
            'snackBarModel',
            'snackBarText',
            'snackBarColor',
            'userDataComplete',
            'institutionDataComplete',
            'firstLoadingLogin'
        ]),
        snackBar: {
            get() {
                return this.snackBarModel
            },
            set(val) {
                this.setSnackBarModel(val)
            }
        },
        showParticles(vm = this) {
            let routes = ['home', 'client.login']
            return routes.includes(vm.$route.name) && vm.$vuetify.breakpoint.mdAndUp
        }
    },
    watch: {
        currentUser(user) {
            var vm = this

            if (!user) {
                return
            }

            let isUserDataComplete = !vm.currentUser.first_name ||
                !vm.currentUser.last_names ||
                !vm.currentUser.email ||
                !vm.currentUser.dni

            vm.setUserDataComplete(isUserDataComplete)

            let isInstitutionDataComplete = !user ||
                !vm.currentUser.institution ||
                !vm.currentUser.institution.name

            vm.setInstitutionDataComplete(isInstitutionDataComplete)

        }
    },
    methods: {
        ...mapMutations([
            'hideSnackBar',
            'setFirstLoginLoading',
            'setSnackBarModel',
            'setUserDataComplete',
            'setCurrentUser',
            'setCurrentProvider',
            'setInstitutionDataComplete',
            'setIsOnline'
        ]),
        ...mapActions(['fetchRegions']),
        delayAppLoad() {
            const vm = this
            setTimeout(function () {
                vm.setFirstLoginLoading(false)
            }, 1500)
        },
        handleScroll(e) {
        },
        onDrawerChange(val) {
            this.showDrawer = val
        },
        onLoginSuccess(user) {

        }
    }
}
</script>


<style>

.kim-card {
    border-radius: 10px !important;
    overflow: hidden;
}

.kim-card.translucent {
    background-color: rgba(255, 255, 255, .8) !important;
}

/* width */
aside::-webkit-scrollbar,
div::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

/* Track */
aside::-webkit-scrollbar-track,
div::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
aside::-webkit-scrollbar-thumb,
div::-webkit-scrollbar-thumb {
    background: #888;
}

/* Handle on hover */
aside::-webkit-scrollbar-thumb:hover,
div::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.v-dialog {
    border-radius: 10px;
}

.v-dialog.v-dialog--fullscreen {
    border-radius: 0;
}

.application.subscription-cancelled {

}

.application--wrap {
    transform: translateZ(0); /*for older browsers*/
    will-change: transform;
    background: rgb(216, 217, 218);
    background: linear-gradient(0deg, rgba(216, 217, 218, 1) 0%, rgba(255, 255, 255, 1) 100%);
}

.application.blurred {
    filter: blur(5px)
}

@media screen and (max-width: 959px) {
    .application.blurred {
        filter: none;
        display: none
    }
}

.snack-bar-custom {
    font-family: Roboto, sans-serif;
}
</style>
